import {Component} from '@angular/core';

@Component({
  selector: "tva-grid",
  templateUrl: "./tv-action-grid.component.html",
  styleUrls: ["./tv-action-grid.component.css"],
  providers: [{
    provide: '',
    useExisting: TvActionGridComponent,
    multi: true
  }]
})
export class TvActionGridComponent {
  //To be implemented
}
